import { Action } from 'redux';
import { IFetchable } from './fetchable';

export enum AsyncActionState {
    NotStarted = 'NotStarted',
    Initiated = 'Initiated',
    Success = 'Success',
    Failure = 'Failure',
}

export interface IAsyncAction<T> extends Action {
    status: AsyncActionState;
    type: T;
}

export interface IAsyncErrorAction<T> extends IAsyncAction<T> {
    error: string;
}

// An action that initiates requests to web services and requires a fresh token
export interface IAsyncFetchableAction<T> extends IAsyncAction<T>, IFetchable {
}
